export function gisToJson(arr) {
  return arr?.map?.(p => ({
    lat: p?.[1],
    lng: p?.[0],
  }))
}

export function jsonToGis(arr) {
  if (!arr) return []
  return arr?.map?.(a => [a?.lng, a?.lat])
}

export function pointToJson(point) {
  return { lat: point?.[1], lng: point?.[0] }
}
